// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experience-module {
    display: flex;
    margin-bottom: 20px;
    width: 80%;
    margin: 0 auto;
}

.company-list {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-left: 3.5px solid #9b1801;
    padding-left: 15px;
    position: relative;
}

.company-name {
    color: #333;
    font-weight: bold;
    cursor: pointer;
    position: relative;
    transition: color 0.3s ease;
}

.company-name.active {
    color: #9b1801;
}

.company-name::after {
    content: '';
    position: absolute;
    left: -18px;
    bottom: -21px;
    height: 3.5px;
    width: 0;
    background-color: #9b1801;
    transition: width 0.7s ease, left 0.7s ease;
}

.company-name.active::after {
    width: calc(100% + 20px);
    left: -18px;
}

.details {
    flex: 3 1;
    transition: opacity 0.4s ease;
    text-align: left;
    font-size: large;
    line-height: 25px;
    margin-left: 15px;
}

.date-range {
    margin: 5px 0;
    font-style: italic;
    color: #c5c5c5;
}

.description {
    margin: 0;
    margin-bottom: 10px;
    text-align: left;
}

.technologies-used {
    margin: 10px 0;
    text-align: left;
}

.experience-module .description span,
.experience-module .technologies-used span {
    opacity: 0;
    animation: fadeIn 0.2s ease-in forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@media (max-width: 1100px) {
    .experience-module {
        width: 90%;
    }
    .date-range {
        font-size: 15px;
    }
    .description {
        font-size: 16px;
    }
    .technologies-used {
        font-size: 16px;
    }
}

@media (max-width: 480px) {
    .experience-module {
        display: flex;
        flex-direction: column;
        margin-bottom: 0;
        width: 100%;
        margin: 0 auto;
    }
    .company-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        border-left: none;
        border-bottom: 3.5px solid #9b1801;
        padding-bottom: 15px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .company-name {
        color: #333;
        font-weight: bold;
        font-size: 12px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        transition: color 0.3s ease;
        margin: 8px;
    }
    .company-name.active {
        color: #9b1801;
    }
    .company-name.active::after {
        width: calc(100% + 0px);
        left: 0px;
    }
    .company-name::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0px;
        height: 3.5px;
        width: 0;
        background-color: #9b1801;
        transition: width 0.7s ease;
    }
    .company-name.active::after {
        width: 100%;
    }
    .details {
        line-height: 22px;
        margin-top: 10px;
    }
    .date-range {
        font-size: 13px;
    }
    .description {
        font-size: 15px;
    }
    .technologies-used {
        font-size: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/ExperienceModule.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;QACjB,kCAAkC;QAClC,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,2BAA2B;QAC3B,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,uBAAuB;QACvB,SAAS;IACb;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,aAAa;QACb,QAAQ;QACR,yBAAyB;QACzB,2BAA2B;IAC/B;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".experience-module {\n    display: flex;\n    margin-bottom: 20px;\n    width: 80%;\n    margin: 0 auto;\n}\n\n.company-list {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    border-left: 3.5px solid #9b1801;\n    padding-left: 15px;\n    position: relative;\n}\n\n.company-name {\n    color: #333;\n    font-weight: bold;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.3s ease;\n}\n\n.company-name.active {\n    color: #9b1801;\n}\n\n.company-name::after {\n    content: '';\n    position: absolute;\n    left: -18px;\n    bottom: -21px;\n    height: 3.5px;\n    width: 0;\n    background-color: #9b1801;\n    transition: width 0.7s ease, left 0.7s ease;\n}\n\n.company-name.active::after {\n    width: calc(100% + 20px);\n    left: -18px;\n}\n\n.details {\n    flex: 3;\n    transition: opacity 0.4s ease;\n    text-align: left;\n    font-size: large;\n    line-height: 25px;\n    margin-left: 15px;\n}\n\n.date-range {\n    margin: 5px 0;\n    font-style: italic;\n    color: #c5c5c5;\n}\n\n.description {\n    margin: 0;\n    margin-bottom: 10px;\n    text-align: left;\n}\n\n.technologies-used {\n    margin: 10px 0;\n    text-align: left;\n}\n\n.experience-module .description span,\n.experience-module .technologies-used span {\n    opacity: 0;\n    animation: fadeIn 0.2s ease-in forwards;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@media (max-width: 1100px) {\n    .experience-module {\n        width: 90%;\n    }\n    .date-range {\n        font-size: 15px;\n    }\n    .description {\n        font-size: 16px;\n    }\n    .technologies-used {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .experience-module {\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 0;\n        width: 100%;\n        margin: 0 auto;\n    }\n    .company-list {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        border-left: none;\n        border-bottom: 3.5px solid #9b1801;\n        padding-bottom: 15px;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n    .company-name {\n        color: #333;\n        font-weight: bold;\n        font-size: 12px;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        position: relative;\n        transition: color 0.3s ease;\n        margin: 8px;\n    }\n    .company-name.active {\n        color: #9b1801;\n    }\n    .company-name.active::after {\n        width: calc(100% + 0px);\n        left: 0px;\n    }\n    .company-name::after {\n        content: '';\n        position: absolute;\n        bottom: -8px;\n        left: 0px;\n        height: 3.5px;\n        width: 0;\n        background-color: #9b1801;\n        transition: width 0.7s ease;\n    }\n    .company-name.active::after {\n        width: 100%;\n    }\n    .details {\n        line-height: 22px;\n        margin-top: 10px;\n    }\n    .date-range {\n        font-size: 13px;\n    }\n    .description {\n        font-size: 15px;\n    }\n    .technologies-used {\n        font-size: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
